import {Field, FieldOperations, OpsCategories, SqlOperation, TableI} from "../../Types";
import {nanoid} from "@reduxjs/toolkit";


const fieldOperations: FieldOperations = {
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
    created_at: [...OpsCategories.range],
    user_id: [...OpsCategories.eq],
    chat_id: [...OpsCategories.eq],
    thread_id: [...OpsCategories.eq],
};

export function tgChatMsg287DefFilters() {
    return []
}

export const TgMsgsTable: TableI = {
    backend: "/287/",
    title: {
        ua: "TG chat msg",
    },
    forAdmin: true,
    pk: 'id',
    defaultOrderedBy: "created_at",
    defaultOrderedWay: "DESC",
    defaultPerPage: 20,
    orderByFields: {
        "created_at": {ua: "Створено", ru: "Дата"},
    },
    fieldOperations: fieldOperations,
    defaultFilters: 'tgChatMsg287DefFilters',
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "№", ru: "№"}, type: "number",
            applyTransform: true
        }, {
            key: "id",
            detailed: true,
            title: {ua: "ID", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "user_id",
            detailed: true,
            title: {ua: "ID Ariston", ru: "№"},
            type: "number",
            applyTransform: true,
            inline: true
        },
        {
            key: "chat_id",
            detailed: true,
            title: {ua: "chat_id", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "thread_id",
            detailed: true,
            title: {ua: "thread_id", ru: "№"},
            type: "number",
            applyTransform: true,
            inline: true
        }, {
            key: "message_id",
            detailed: true,
            title: {ua: "message_id", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "type",
            detailed: true,
            title: {ua: "Тип", ru: "№"},
            type: "string",
            applyTransform: true
        },
        {
            key: "edit_of",
            detailed: true,
            title: {ua: "edit_of", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "created_at",
            title: {ua: "Створено", ru: "Дата"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: true,
            inline: true,
        },
        {
            key: "original_message_id",
            detailed: true,
            title: {ua: "original_message_id", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "original_chat_id",
            detailed: true,
            title: {ua: "original_chat_id", ru: "№"},
            type: "number",
            applyTransform: true
        },

    ] as Field[]
}


